import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

/**
 * フォームの情報
 */
const infoHeadTitleList: any[] = [
  {
    headTitle: "選択",
  },
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設所在地",
  },
  {
    headTitle: "ステータス",
  },
];

const infoHeadTitleMemoList: any[] = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "取下げ日",
    keyword: "cancelDate",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    type: "date",
    disabled: true,
  },
];
export { infoHeadTitleList, infoHeadTitleMemoList, fakeTableList };
